import React from "react";



export default function Footer() {
    return (
        
            <div className="footer">
           <a href="https://github.com/AnnaPCH/weather-react" rel="noreferrer" target= "_blank" >Open-source code</a> by Anna Papadaki
             </div> 
    
    );
}